import Vue from 'vue'
import axios from 'axios'
import store from '../store';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Laravel Sanctum Error
        if ([401, 419].indexOf(error.response.status) != -1) {
            store.dispatch('logined', false)
        }

        // Syntax Error
        // index.htmlはApp.vue:fetchAppHashで確認するためだけなのでskip
        if (error.response.status >= 500
            && !error.request.responseURL.match(/^https?:\/\/[^/]+\/index.html/)) {
            Vue.$toast.error(error.response?.data?.message ?? 'Server Error')
        }

        // バリデーションエラー
        if (error.response.status == 422) {
            for (var val_error in error.response?.data?.message) {
                const errors = error.response?.data?.message[val_error].join("\n");
                Vue.$toast.error(errors);
            }
            
        }

        return Promise.reject(error);
    }
);
export default axios;
